import React from 'react'
import { TrendContext, TrendState } from './trend.context'

const initialState: TrendState = {
  isDragging: false,
}

export const TrendProvider = ({
  children,
}: {
  children?: React.ReactNode
}): JSX.Element => {
  const [state, setState] = React.useState<TrendState>(initialState)

  return (
    <TrendContext.Provider
      value={{
        isDragging: state.isDragging,
        setDragState: setState,
      }}
    >
      {children}
    </TrendContext.Provider>
  )
}
